import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=28f13be4"
import script from "./GroupEdit.vue?vue&type=script&lang=ts"
export * from "./GroupEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports